import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Scrollbar } from "swiper";
export const TabSwiper = ({ t, options = [], onChange }) => {
    const [tab, setTab] = useState(undefined);

    const changeTab = (t) => {
        setTab(t);
        onChange?.(t)
    }

    return (
        <div className='claim-swiper'>
            <Swiper
                style={{ height: 52 }}
                slidesPerView={7}
                breakpoints={
                    {
                        200:{
                            slidesPerView: 4,
                        },
                        568:{
                            slidesPerView: 5,
                        },
                        768:{
                            slidesPerView: 6,
                        },
                        1200:{
                            slidesPerView: 7,
                        }
                    }
                }
                scrollbar={{
                    el: '.swiper-scrollbar',
                    draggable: true,
                    dragSize: 20
                }} 
            >
                {options.map((item, index) => <SwiperSlide className={(item.value === tab || (tab === undefined && index === 0)) ? "active" : ""} onClick={() => changeTab(item.value)} key={item.value} >{t(`${item.label}`)}</SwiperSlide>)}
                <div class="swiper-scrollbar"></div>
            </Swiper>
        </div>
    )
}
